import classnames from 'classnames'
import * as React from 'react'

import Button from 'airship/patterns/button'
import {ButtonStyle} from 'airship/patterns/button/Button'

export interface Props {
  /** call back for file data */
  onChange: React.ChangeEventHandler<HTMLInputElement>
  /** accepted file types https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#attr-accept */
  accept: string
  /** disables file upload button when true */
  disabled?: boolean
  /** Text for the button to open the uploader */
  buttonText: string
  /** Optional style for different kinds of buttons */
  buttonStyle?: ButtonStyle
  /** Extra classes to be applied to the button */
  displayClasses?: string
  /** Optional identifier for the AQA */
  dataSeleniumTarget?: string
}

const FileUpload: React.FC<Props> = ({
  accept,
  onChange,
  disabled,
  buttonText,
  buttonStyle,
  displayClasses,
  dataSeleniumTarget = 'file-uploader',
}) => {
  const uploadRef = React.useRef<HTMLInputElement>(null)
  const cls = classnames('u-space-bottom-06', displayClasses)

  return (
    <>
      <input
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick={(event: any) => {
          if (event.target.value) event.target.value = null
        }}
        type="file"
        ref={uploadRef}
        className="hidden"
        accept={accept}
        onChange={onChange}
        data-testid="file-uploader"
        data-selenium-target={dataSeleniumTarget}
      />
      <Button
        disabled={disabled}
        onClick={() => uploadRef.current?.click()}
        style={buttonStyle}
        displayClasses={cls}
        dataSeleniumTarget="choose-bt"
      >
        {buttonText}
      </Button>
    </>
  )
}

export default FileUpload
